import Vue from "vue"
import "./plugins/axios"
import App from "./App.vue"
import store from "./store"
import router from "./router"
import vuetify from "./plugins/vuetify"
import Vuelidate from "vuelidate"
import VueCookies from "vue-cookies"
import Portal from "portal-vue"
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"
import Debug from "@/components/debug/Debug.vue"

import * as Sentry from "@sentry/vue"
import { BrowserTracing } from "@sentry/tracing"

Vue.config.productionTip = false

/**
 * Register plugins.
 */

Vue.use(Vuelidate)
Vue.use(Portal)
Vue.use(VueCookies)
Vue.use(Toast, {
  maxToasts: 20,
  newestOnTop: true,
  position: "top-right",
  timeout: 8000,
  closeOnClick: true,
  pauseOnFocusLoss: false,
  pauseOnHover: true,
  draggable: false,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
})

/**
 * Register some components globally.
 */

Vue.component("Debug", Debug)

/**
 * Register components in specified contexts
 * automatically with given prefix.
 */

const autoloadConfig = [
  {
    prefix: "Ui",
    context: require.context("./components/ui", false, /\.vue$/i),
    // Component `Button` in `ui` directory will be
    // available as `ui-button` in all templates.
  },
  // {
  //   prefix: "Icon",
  //   context: require.context("./components/icon", false, /\.vue$/i),
  // },
]

autoloadConfig.forEach(({ prefix, context }) => {
  context.keys().forEach(key => {
    const name = key
      .split("/")
      .pop()
      ?.split(".")[0]

    Vue.component(`${prefix}${name}`, context(key).default)
  })
})

if (
  process.env.NODE_ENV === "production" &&
  typeof process.env.VUE_APP_SENTRY_DSN === "string"
) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  })
}

/**
 * Instantiate Vue application.
 */

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App), // TODO fix type
  components: { App },
  created() {
    const cid = process.env.VUE_APP_CLIENT_ID
    // let tid = null
    const appCode = process.env.VUE_APP_APP_CODE

    if (!appCode) {
      throw new Error("Unknown app code, please check your .env file.")
    }

    if (!cid) {
      throw new Error("Unknown OAuth2 client ID, please check your .env file.")
    }

    // // get Tenant ID from cookies or from .env in development mode
    // if (process.env.NODE_ENV === "production") {
    //   if (!Vue.$cookies.isKey("cid")) {
    //     throw new Error("Unknown OAUTH2 client ID; cookie not found.")
    //   }
    //   if (!Vue.$cookies.isKey("tid")) {
    //     throw new Error("Unknown tenant ID; cookie not found.")
    //   }
    //
    //   cid = Vue.$cookies.get("cid")
    //   tid = Vue.$cookies.get("tid")
    // } else {
    //   if (Vue.$cookies.isKey("cid")) {
    //     cid = Vue.$cookies.get("cid")
    //   } else {
    //     cid = process.env.VUE_APP_CLIENT_ID
    //   }
    //
    //   if (!cid) {
    //     throw new Error(
    //       "Unknown OAUTH2 client ID; cookie neither ENV variable found."
    //     )
    //   }
    //
    //   if (Vue.$cookies.isKey("tid")) {
    //     tid = Vue.$cookies.get("tid")
    //   } else {
    //     tid = process.env.VUE_APP_TENANT_ID
    //   }
    //
    //   if (!cid) {
    //     throw new Error("Unknown tenant ID; cookie neither ENV variable found.")
    //   }
    // }
    //
    store.dispatch("app/loadAppConfig", { appCode, cid })
  },
}).$mount("#app")
